import styled from 'styled-components';

export const Container = styled.div`
  .bidding {
    &-bg-header {
      background: ${(props) => props.theme.$dark};
      border-top-left-radius: 0;
    }

    .card-header {
      .item {
        color: ${(props) => props.theme.$white};

        &-label {
          color: ${(props) => props.theme.$white};
        }
      }
    }

    &-item-header-buttons {
      display: contents;
      position: relative;

      & > div {
        width: 38px;
        height: 20px;
      }
    }

    &-item-header-button {
      height: auto;
      overflow: hidden;
      position: absolute;
      top: -12px;
      left: -4px;

      svg {
        vertical-align: middle;
      }
    }

    &-favorited-icon {
      left: 0px;
      top: -1px;
    }
    [class*='bidding-situation-'] {
      background-color: ${(props) => props.theme.$gray600};
      color: ${(props) => props.theme.$white};
      padding: 3px 7px;
    }

    .bidding-situation-nova {
      background-color: ${(props) => props.theme.$primary_green};
    }

    .bidding-situation-suspensa {
      background-color: ${(props) => props.theme.$warning};
      color: ${(props) => props.theme.$black};
    }

    .bidding-situation-suspensa-sine-die {
      background-color: ${(props) => props.theme.$warning};
      color: ${(props) => props.theme.$black};
    }

    .bidding-situation-urgente {
      background-color: ${(props) => props.theme.$danger};
    }
  }
`;
